<template>
    <div id="additionalInfoSection" class="main-area">
      <PageTop title="Ek Bilgiler" />
      <div class="radio-button-area d-flex flex-row">
        <div class="radio-button-wrapper d-flex flex-column">
          <div class="radio-button-info d-flex flex-column">
            <h3>{{ radioButtonsInfo[0].title }}</h3>
            <p>{{ radioButtonsInfo[0].text }}</p>
          </div>
          <div class="additional-info radio-button d-flex flex-column">
            <RadioButtonGroup
              :name="radioButtonsInfo[1].title"
              :options="radioButtonOptions"
              @select="handleSelectRadio(radioButtonsInfo[0].id, radioButtonOptions.id, $event)"
            >
              <span class="radio-button-label">Evet</span>
            </RadioButtonGroup>
            <div v-if="customProductOption" class="input-area flex-row">
              <div class="input-area-with-info">
                <Input
                  type="text"
                  label="Seçenek Türü"
                  :isError="customProductOptionErrorText"
                  @focus="checkError"
                  v-model:value="customProductOptionInput"
                  helperText="En fazla 3 seçenek sunabilirsiniz."
                />
                <p :class="{ 'error-text': customProductOptionErrorText }">{{ customProductOptionErrorText }}</p>
              </div>
              <Button secondary class="input-area-button"  :class="{'disabled-button': customProductOptionList.length === 3}" :disabled="!customProductOptionInput || customProductOptionList.length === 3" @click="addToProductList()">Ekle</Button>
            </div>
            <div v-if="customProductOption && customProductOptionList">
              <ul class="variants">
                <li v-for="(item) in customProductOptionList">
                  <span>{{item.text}}</span>
                  <Button @click="removeFromProductList(item.id)" link class="remove-single-variant">
                    <img src="@/assets/images/icons/icons-close-white.svg" />
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="radio-button-wrapper d-flex flex-column">
          <div class="radio-button-info d-flex flex-column">
            <h3>{{ radioButtonsInfo[1].title }}</h3>
            <p>{{ radioButtonsInfo[1].text }}</p>
          </div>
          <div class="additional-info radio-button d-flex flex-column">
            <RadioButtonGroup
              :name="radioButtonsInfo[1].title"
              :options="radioButtonOptions"
              @select="handleSelectRadio(radioButtonsInfo[1].id, radioButtonOptions.id, $event)"
            >
              <span class="radio-button-label">Evet</span>
            </RadioButtonGroup>
            <div v-if="amountLimit" class="input-area flex-row">
              <div class="input-area-with-info">
                <Input
                  type="number"
                  :isOnlyNumber="true"
                  label="Max Satış Adedi"
                  :isError="amountLimitErrorText"
                  @blur="checkError"
                  v-model:value="maxSalesLimit"
                />
                <p :class="{ 'error-text': amountLimitErrorText }">{{ amountLimitErrorText }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex';
import PageTop from '@/components/Page/PageTop.vue'
import { RadioButtonGroup, Input, Button } from "@n11/so-ui-components"

const store = useStore();
const customProductOption = ref(null)
const amountLimit = ref(null)
const customProductOptionInput = ref("")
const maxSalesLimit = ref("")
const customProductOptionErrorText = ref(null)
const amountLimitErrorText = ref(null)

const radioButtonsInfo = ref([
	{
		id: 0,
		title: "Kişiselleştirilmiş ürün seçeneği sunuyor musunuz?",
		text: "Müşterilerinize kişiselleştirilmiş ürün seçeneği sunmak istiyorsanız işaretleyebilirsiniz."
	},
	{
		id: 1,
		title: "Ürünün satışında adet limiti var mı?",
		text: "Müşterinin bir siparişinde, ürün seçeneği bazında satın alabileceği adet limitiniz varsa seçebilirsiniz."
	}
])

const customProductOptionList = ref([])

const radioButtonOptions = [
  { id: '0', name: 'Evet' },
  { id: '1', name: 'Hayır' },
];

const handleSelectRadio = (questionId, answerId, selectedAnswer) => {
  if ( questionId === 0) {
    customProductOption.value = selectedAnswer.id === "0" ? true : false
  }
  else if ( questionId === 1)
    amountLimit.value = selectedAnswer.id === "0" ? true : false
}

const removeFromProductList = (id) => {
  customProductOptionList.value = customProductOptionList.value.filter((product) => product.id !== id)
  checkError()
}

const addToProductList = () => {
  if (!customProductOptionInput.value) return;
  if (customProductOptionList.value.find((item)=> item.text.toLocaleLowerCase('tr-TR') === customProductOptionInput.value.toLocaleLowerCase('tr-TR'))) {
    store.commit("common/SET_TOASTER_DATA", {
      type: 'error',
      title: '',
      description: "Bu seçenek daha önce eklenmiştir.",
    });
    customProductOptionErrorText.value = "";
    return;
  }
  customProductOptionList.value.push({
    id: customProductOptionList.value.length,
    text: customProductOptionInput.value
  })
  customProductOptionInput.value = null
} 

const checkError = () => {
  if (customProductOptionList.value.length === 3) customProductOptionErrorText.value = "En fazla 3 seçenek sunabilirsiniz.";
  else customProductOptionErrorText.value = null;
  if (amountLimit.value && !maxSalesLimit.value) amountLimitErrorText.value = "Ürünün satışında adet limiti belirtmek istemiyorsanız seçiminizi değiştiriniz.";
  else if (parseInt(maxSalesLimit.value) > 999) amountLimitErrorText.value = "Ürünün satışında adet limiti maksimum 999 olabilir.";
  else amountLimitErrorText.value = null;
}

const getAdditionalInfo = () => {
  let customOptionIsValid = true;
  let amountLimitIsValid = true;
  if (customProductOption.value && customProductOptionList.value.length === 0) {
    customProductOptionErrorText.value = "Kişiselleştirilmiş ürün seçeneği sunmuyorsanız seçiminizi değiştiriniz.";
    customOptionIsValid = false;
  }
  else customProductOptionErrorText.value = null

  if (amountLimit.value && !maxSalesLimit.value) {
    amountLimitErrorText.value = "Ürünün satışında adet limiti belirtmek istemiyorsanız seçiminizi değiştiriniz.";
    amountLimitIsValid = false
  }
  else amountLimitErrorText.value = null;

  return {
    data: {
      customProductOptionList: customProductOptionList.value,
      maxSalesLimit: maxSalesLimit.value
    },
    isValid: amountLimitIsValid && customOptionIsValid,
  }
}

defineExpose({
  getAdditionalInfo
})
</script>
<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';


.additional-info :deep(.radioButton-list) {
  flex-direction: row;
}
.additional-info :deep(.input-label) {
  pointer-events: none;
}

.main-area {
  width: 100%;
  display: flex;
  gap: 16px;
  padding: 24px;
  border: 1px solid #D3D6DF;
  border-radius: 8px;

  .radio-button-area {
    gap: 24px;

    .radio-button-wrapper {
      flex: 1;
      gap: 12px;
      justify-content: space-between;
      height: max-content;

      &:not(:last-child) {        
        border-right: 1px solid $colorD20;
      }

      .radio-button-info {
        gap: 6px;
        width: 92%;

        h3 {
          font-size: 14px;
          line-height: 18px;
          color: $colorN80;
          font-weight: 600;
        }

        p {
          font-size: 11px;
          line-height: 14px;
          color: $colorN80;
        }

      }

      .radio-button {
        gap: 24px;
        cursor: pointer;
        .radio-button-label {
          font-size: 12px;
          line-height: 16px;
          color: $colorN80;
        }
      }

    }
  }

  .input-area {
    display: flex;
    flex-direction: row;
    max-width: 450px;
    gap: 8px;

    &-with-info {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;

      p {
        font-size: 11px;
        line-height: 14px;
        padding-left: 12px;
        color: $colorN60;
      }

      .error-text {
        color: $colorE50;
      }
    }

    &-button {
      padding: 11px 20px !important;
      border-radius: 6px;
      font-size: 14px;
      line-height: 18px;
      height: max-content;
      width: max-content;
    }

    .disabled-button {
      border: transparent;
    }
  }

  .variants {
    display: flex;
    flex-flow: wrap;
    gap: 4px;
    max-width: 384px;

    li {
      border: 1px solid $colorN40;
      border-radius: 20px;
      background-color: $colorN00;
      padding: 6px 16px;
      display: inline-flex;
      align-items: center;
      gap: 4px;

      font-family: Open Sans;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      letter-spacing: -0.05px;
    }

    .remove-single-variant {
      color: $colorM50;
      font-family: Open Sans;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.05px;
      text-decoration: none;
      background-color: $colorN30;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      padding: 4px;
      display: flex;
      align-items: center;
      flex-direction: column;
      transition: background-color ease-in-out 150ms;

      &:hover {
        background-color: $colorN70;
      }

      img {
        width: 16px;
      }
    }
  }
}


.flex-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 24px;

  .page-title {
    font-size: 20px;
    line-height: 26px;
    font-weight: 700;
    color: $colorN80;
  }

  .page-description {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: $colorN80;

    span {
      font-weight: 600;
    }
  }
}
</style>

  